import React, { useRef, useState, useContext, useEffect } from "react";
import csvtojson from "csvtojson";
import { FaFileCsv } from "react-icons/fa6";
import { Button, Typography, Stack } from "@mui/material";

import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import "../../Style/dialogStyle.scss";

import csv from "../../Assets/csv.png";

export default function ImportStudentFromCSV({ setCSVData, open }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);


  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const csvText = e.target?.result;
      const json = await csvtojson().fromString(csvText);
      setCSVData(json);
    };
    reader.readAsText(file);
  };

  useEffect(() => {
    setFileName("")
  },[open])

  return (
    <div>
      {/* Hidden File Input */}
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />

      {/* <Button
        className="btn-create-style"
        onClick={() => fileInputRef.current?.click()}
        startIcon={<FaFileCsv className="icon-add" />}
      >
        <Typography className={language === "kh" ? "btn-txt-kh" : "btn-txt"}>
          {t("import")}
        </Typography>
      </Button> */}

      <Button
        className="import-csv-container"
        onClick={() => fileInputRef.current?.click()}
        // startIcon={<FaFileCsv className="icon-add" />}
      >
        <Stack direction="column" spacing={1} alignItems="center">
          <img src={csv} alt="csv" style={{ width: "90px" }} />
          <Typography
            className={language === "kh" ? "import-txt-kh" : "import-txt"}
          >
            {fileName ? fileName : t("select_file")}
          </Typography>
        </Stack>
      </Button>
    </div>
  );
}
